var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f57f21;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.991 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.991 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M56.6,27.618a4.676,4.676,0,0,1-8.46-2.709V23.244H46.462a4.637,4.637,0,1,1,0-9.274h1.677V12.306a4.654,4.654,0,0,1,3.875-4.569A10.152,10.152,0,1,0,36.771,18.658C29.355,21.206,26.216,29.13,25.018,37.163A2.492,2.492,0,0,0,27.508,40H56.77a2.5,2.5,0,0,0,2.489-2.837A36.422,36.422,0,0,0,56.6,27.618ZM38.824,10.089a1.514,1.514,0,0,1-3.028,0,6.333,6.333,0,0,1,6.347-6.3,1.5,1.5,0,1,1,0,3.006A3.31,3.31,0,0,0,38.824,10.089Z",
    transform: "translate(-24.991 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.72 10.471)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M268.753,129.6h-4.467v-4.467a1.832,1.832,0,0,0-1.834-1.834h0a1.839,1.839,0,0,0-1.843,1.834V129.6h-4.467a1.834,1.834,0,1,0,0,3.669h4.467v4.467a1.834,1.834,0,0,0,1.843,1.834h0a1.832,1.832,0,0,0,1.834-1.834V133.27h4.467a1.834,1.834,0,1,0,0-3.669Z",
    transform: "translate(-254.307 -123.3)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.402641d4.svg";
export { ForwardRef as ReactComponent };